import { Group, TextProps, useMantineTheme } from "@mantine/core"
import { IconCheck, IconX } from "@tabler/icons-react"

import { Missing } from "../Missing/Missing"

import { TextCell } from "./TextCell"

type Props = {
  value?: boolean
  withText?: boolean
  yesText?: string
  noText?: string
  fallbackValue?: React.ReactNode
} & TextProps

export const BoolCell = ({
  value,
  withText = true,
  yesText = "yes",
  noText = "no",
  fallbackValue,
  ...textProps
}: Props) => {
  const { colors } = useMantineTheme()

  if (value === true) {
    return (
      <Group gap={4}>
        <IconCheck color="var(--mantine-color-success)" size={16} />
        {withText && <TextCell {...textProps} value={yesText} />}
      </Group>
    )
  } else if (value === false) {
    return (
      <Group gap={4}>
        <IconX color={colors.red[6]} size={16} />
        {withText && <TextCell {...textProps} value={noText} />}
      </Group>
    )
  }

  return fallbackValue ?? <Missing {...textProps} />
}
